import z from "zod/v4"

// TODO: should there be more of these? Should this even be a closed set?
export type SponsorT = string
// FIXME: this is used for ESK and MSK id fields at the moment, need to find a way to differentiate
// Also not sure what the "user" type is used for now
export type EskTypeT = "user" | "HOST" | number

export type MSKType = {
  id: string
  name: string
  tts_id: string
  created_by: string
  sponsor_id: string
  active: boolean
  created_at: string
  default: boolean
  _id: string
  avatar_id: string
  avatarImage: string
  avatarRiveFile: string
}

export type ESKType = {
  name: string
  type: string
  introduction: string
  system_prompt: string
  allowed_for_switch_cm: boolean
  tts_id: string
  active: boolean
  created_at: string
  additional_information?: string
  avatar_id: string
  category?: string
  created_by: string
  expertise?: string
  topic_id?: string
}

export type CMTopic = {
  id: string
  displayName: string
  key: string
  subtopics: CMTopic[]
  priority: number
  not_removable: boolean
  sk_id?: string
}

export type SponsorType = {
  name: string
  id: string
  active: boolean
  created_at: string
  esk_types: ESKType[]
  cm_topics?: CMTopic[]
}

// FIXME: this isn't at all what the docs say
export type MemberType = {
  enable_encryption: boolean
  facts: Record<string, any>
  approved_facts: [string]
  mskId: string
  new_user: boolean
  sme: boolean
  sponsor_admin: boolean
  sponsors: string[]
  user_id: string
}

export type MemberFactField = {
  name: string
  _id: string
  active: boolean
  created_at: string
  updated_at: string
  sponsor_id: string
  group_id: string | null
  fact_id: string | null
  // Headers are just user configurable groups
  header_id: string
  fact_type: "core" | "group" | "sponsor" | "header"
  fact_order: number
  // this is `null` in the case of groups and headers which aren't actually fields
  field_type: "string" | "enum" | "date" | null
  extract_instructions?: string
  usage_instructions?: string
  enums?: string[] | null
  description?: string
  created_by?: string
  project?: string
  updated_by?: string
  list_order?: number | null
  group?: string | null
  disable_extraction?: boolean
  show_empty_sponsor_fact_to_member?: boolean
  fact_response_length?: "short" | "medium" | "long" | null
}

export const MemberFactFieldSchema = z.object({
  name: z.string(),
  _id: z.string(),
  active: z.boolean(),
  created_at: z.string(),
  updated_at: z.string(),
  sponsor_id: z.string(),
  group_id: z.string().nullable(),
  fact_id: z.string().nullable(),
  header_id: z.string(),
  fact_type: z.enum(["core", "group", "sponsor", "header"]),
  fact_order: z.number(),
  field_type: z.enum(["string", "enum", "date"]).nullable(),
  extract_instructions: z.string().optional(),
  usage_instructions: z.string().optional(),
  enums: z.array(z.string()).nullable().optional(),
  description: z.string().optional(),
  created_by: z.string().optional(),
  project: z.string().optional(),
  updated_by: z.string().optional(),
  list_order: z.number().nullable().optional(),
  group: z.string().nullable().optional(),
  disable_extraction: z.boolean().optional(),
  show_empty_sponsor_fact_to_member: z.boolean().optional(),
  fact_response_length: z.enum(["short", "medium", "long"]).nullable().optional(),
})
